import { ConfigProvider } from "antd";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import AiInterviewLogin from "./pages/AiInterviewLogin";
import AiInterviewPreview from "./pages/AiInterviewPreview";
import InterviewCompleted from "./components/interviewCompleted/InterviewCompleted";
// import Report from "./pages/Report";
import InterviewAnalysisMain from "./components/interviewAnalysis/InterviewAnalysisMain";
import InterviewReport from "./pages/InterviewReport";
import InterviewTranscript from "./pages/InterviewTranscript";
import InterviewSchedule from "./pages/InterviewSchedule";

function App() {
  return (
    <ConfigProvider
      theme={{
        token: {
          fontFamily: "Inter",
        },
      }}
    >
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<AiInterviewLogin />} />
          <Route path="/preview" element={<AiInterviewPreview />} />
          <Route path="/interview-completed" element={<InterviewCompleted />} />
          <Route path="/report" element={<InterviewReport />} />
          <Route path="/interview-analysis" element={<InterviewAnalysisMain />} />
          <Route path="/transcript" element={<InterviewTranscript />} />
          <Route path="/interview-demo-schedule" element={<InterviewSchedule />} />
        </Routes>
      </BrowserRouter>
    </ConfigProvider>
  );
}

export default App;
